import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ContainedButton } from "components/ContainedButton";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { CURRENT_PATH } from "utils/constants";

const useStyles = makeStyles((theme: any) => ({
  alertLink: {
    fontWeight: 'bold',
    textDecoration: 'none',
    width: "100%",
    marginTop: "1rem",
  },
  alertLinkIcon: { marginLeft: theme.spacing(0.7) },
  noDataFoundText: {
    fontWeight: 500,
    color: "black",
    fontSize: "2rem",
  },
  icon: {
    height: "10rem !important",
    width: "10rem !important",
  },
  paper: {
    width: "100%", height: "100%", padding: "2rem", display: "flex", justifyContent: "center", alignItems: "center"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "35rem",
    gap: "0.7rem",
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  contentContainer: {
    marginTop: "1rem", height: "60vh"
  },
  titleContainer: {
    fontSize: "1rem", textAlign: "center"
  }
}));

export const NoDataFoundAlert = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  return (
    <Box className={classes.contentContainer}>
      <Paper className={classes.paper}>
        <Box className={classes.container}>
          <FontAwesomeIcon icon="folder-minus" className={classes.icon} />
          <Typography className={classes.noDataFoundText}>{t('orders:noDataFoundMessage')}</Typography>
          <Typography className={classes.titleContainer}>
            {`${t('policyInfoAndRates:alert-p-1')} `}
          </Typography>
          <Link
            to={`/orders/details/${id}/properties/`}
            className={classes.alertLink}
            onClick={() => {
              localStorage.setItem(
                CURRENT_PATH,
                JSON.stringify({ view: 'properties' })
              );
            }}
          >
            <ContainedButton text={t('orders:goToPropertiesButton')} width="100%" height="2.5rem" />
          </Link>
        </Box>
      </Paper>
    </Box>
  );
};
